export enum Age {
  under_18 = "18 and under",
  $19_24 = "19-24",
  $25_39 = "25-39",
  $40_55 = "40-55",
  $56_and_over = "56 and over",
}
